export default __webpack_public_path__ + "static/spinnaker-624f0973059703214341bc980fce8938.png";